<template lang="pug">
  include /mixins
  video(
    ref="videoRef"
    controls
    playsinline
    :autoplay="isAutoplay"
  )
    source(
      :src="finalHlsUrl"
      type="hlsType"
    )
</template>

<script>
import Hls from 'hls.js'

export default {
  props: {
    hlsUrl: {},
    response: {},
    isAutoplay: {},
  },

  computed: {
    localHlsUrl() {
      return this.response?.result?.playback?.hls
    },

    finalHlsUrl() {
      return this.hlsUrl || this.localHlsUrl
    },
  },

  data() {
    return {
      hlsType: 'application/x-mpegURL',
    }
  },

  mounted() {
    if (!this.finalHlsUrl) return

    this.simulateClickForAutoplay()

    this.loadVideo()
  },

  beforeDestroy() {
    this.stopVideo()
  },

  methods: {
    simulateClickForAutoplay() {
      if (this.isAutoplay) {
        const clickEvent = new Event('click', { bubbles: true })

        document.body.dispatchEvent(clickEvent)
      }
    },

    loadVideo() {
      const { videoRef } = this.$refs

      if (Hls.isSupported()) {
        const hls = new Hls()

        hls.loadSource(this.finalHlsUrl)
        hls.attachMedia(videoRef)
      } else if (videoRef.canPlayType(this.hlsType)) {
        videoRef.src = this.finalHlsUrl
      }
    },

    stopVideo() {
      const { videoRef } = this.$refs

      if (videoRef) {
        videoRef.pause()

        videoRef.src = ''

        videoRef.load()
      }

      if (this.hls) {
        this.hls.detachMedia()
        this.hls.destroy()

        this.hls = null
      }
    },
  },
}
</script>
